import { render, staticRenderFns } from "./app-page.vue?vue&type=template&id=5a71d612&scoped=true"
import script from "./app-page.vue?vue&type=script&lang=js"
export * from "./app-page.vue?vue&type=script&lang=js"
import style0 from "./app-page.vue?vue&type=style&index=0&id=5a71d612&prod&lang=scss"
import style1 from "./app-page.vue?vue&type=style&index=1&id=5a71d612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71d612",
  null
  
)

export default component.exports